export default __webpack_public_path__ + "static/media/goshen91.3c43e28a.jpg";